// extracted by mini-css-extract-plugin
module.exports = {"grid":"default_grid__mJFTP","sponsor":"default_sponsor__t__Al"};